// color-palettes.ts
export const colorPaletteTokens = {
  "primary": {
    "0": {
      "value": "#000000",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#000000",
        "type": "color"
      },
      "name": "Primary0",
      "attributes": {
        "category": "primary",
        "type": "0"
      },
      "path": [
        "primary",
        "0"
      ]
    },
    "10": {
      "value": "#2b0f00",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#2B0F00",
        "type": "color"
      },
      "name": "Primary10",
      "attributes": {
        "category": "primary",
        "type": "10"
      },
      "path": [
        "primary",
        "10"
      ]
    },
    "20": {
      "value": "#4a1f00",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#4A1F00",
        "type": "color"
      },
      "name": "Primary20",
      "attributes": {
        "category": "primary",
        "type": "20"
      },
      "path": [
        "primary",
        "20"
      ]
    },
    "30": {
      "value": "#7a3200",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#7A3200",
        "type": "color"
      },
      "name": "Primary30",
      "attributes": {
        "category": "primary",
        "type": "30"
      },
      "path": [
        "primary",
        "30"
      ]
    },
    "40": {
      "value": "#ff6801",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FF6801",
        "type": "color"
      },
      "name": "Primary40",
      "attributes": {
        "category": "primary",
        "type": "40"
      },
      "path": [
        "primary",
        "40"
      ]
    },
    "50": {
      "value": "#ff7a26",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FF7A26",
        "type": "color"
      },
      "name": "Primary50",
      "attributes": {
        "category": "primary",
        "type": "50"
      },
      "path": [
        "primary",
        "50"
      ]
    },
    "60": {
      "value": "#ff944d",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FF944D",
        "type": "color"
      },
      "name": "Primary60",
      "attributes": {
        "category": "primary",
        "type": "60"
      },
      "path": [
        "primary",
        "60"
      ]
    },
    "70": {
      "value": "#ffad73",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFAD73",
        "type": "color"
      },
      "name": "Primary70",
      "attributes": {
        "category": "primary",
        "type": "70"
      },
      "path": [
        "primary",
        "70"
      ]
    },
    "80": {
      "value": "#ffc699",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFC699",
        "type": "color"
      },
      "name": "Primary80",
      "attributes": {
        "category": "primary",
        "type": "80"
      },
      "path": [
        "primary",
        "80"
      ]
    },
    "90": {
      "value": "#ffe2cc",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFE2CC",
        "type": "color"
      },
      "name": "Primary90",
      "attributes": {
        "category": "primary",
        "type": "90"
      },
      "path": [
        "primary",
        "90"
      ]
    },
    "95": {
      "value": "#fff1e6",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFF1E6",
        "type": "color"
      },
      "name": "Primary95",
      "attributes": {
        "category": "primary",
        "type": "95"
      },
      "path": [
        "primary",
        "95"
      ]
    },
    "99": {
      "value": "#fffbf8",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFBF8",
        "type": "color"
      },
      "name": "Primary99",
      "attributes": {
        "category": "primary",
        "type": "99"
      },
      "path": [
        "primary",
        "99"
      ]
    },
    "100": {
      "value": "#ffffff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFFFF",
        "type": "color"
      },
      "name": "Primary100",
      "attributes": {
        "category": "primary",
        "type": "100"
      },
      "path": [
        "primary",
        "100"
      ]
    }
  },
  "neutral": {
    "0": {
      "value": "#000000",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#000000",
        "type": "color"
      },
      "name": "Neutral0",
      "attributes": {
        "category": "neutral",
        "type": "0"
      },
      "path": [
        "neutral",
        "0"
      ]
    },
    "10": {
      "value": "#121212",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#121212",
        "type": "color"
      },
      "name": "Neutral10",
      "attributes": {
        "category": "neutral",
        "type": "10"
      },
      "path": [
        "neutral",
        "10"
      ]
    },
    "20": {
      "value": "#1e1e1e",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#1E1E1E",
        "type": "color"
      },
      "name": "Neutral20",
      "attributes": {
        "category": "neutral",
        "type": "20"
      },
      "path": [
        "neutral",
        "20"
      ]
    },
    "25": {
      "value": "#242424",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#242424",
        "type": "color"
      },
      "name": "Neutral25",
      "attributes": {
        "category": "neutral",
        "type": "25"
      },
      "path": [
        "neutral",
        "25"
      ]
    },
    "30": {
      "value": "#2a2a2a",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#2A2A2A",
        "type": "color"
      },
      "name": "Neutral30",
      "attributes": {
        "category": "neutral",
        "type": "30"
      },
      "path": [
        "neutral",
        "30"
      ]
    },
    "40": {
      "value": "#3a3a3a",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#3A3A3A",
        "type": "color"
      },
      "name": "Neutral40",
      "attributes": {
        "category": "neutral",
        "type": "40"
      },
      "path": [
        "neutral",
        "40"
      ]
    },
    "50": {
      "value": "#5c5c5c",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#5C5C5C",
        "type": "color"
      },
      "name": "Neutral50",
      "attributes": {
        "category": "neutral",
        "type": "50"
      },
      "path": [
        "neutral",
        "50"
      ]
    },
    "60": {
      "value": "#7a7a7a",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#7A7A7A",
        "type": "color"
      },
      "name": "Neutral60",
      "attributes": {
        "category": "neutral",
        "type": "60"
      },
      "path": [
        "neutral",
        "60"
      ]
    },
    "70": {
      "value": "#a0a0a0",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#A0A0A0",
        "type": "color"
      },
      "name": "Neutral70",
      "attributes": {
        "category": "neutral",
        "type": "70"
      },
      "path": [
        "neutral",
        "70"
      ]
    },
    "80": {
      "value": "#c6c6c6",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#C6C6C6",
        "type": "color"
      },
      "name": "Neutral80",
      "attributes": {
        "category": "neutral",
        "type": "80"
      },
      "path": [
        "neutral",
        "80"
      ]
    },
    "90": {
      "value": "#e0e0e0",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#E0E0E0",
        "type": "color"
      },
      "name": "Neutral90",
      "attributes": {
        "category": "neutral",
        "type": "90"
      },
      "path": [
        "neutral",
        "90"
      ]
    },
    "95": {
      "value": "#f2f2f2",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#F2F2F2",
        "type": "color"
      },
      "name": "Neutral95",
      "attributes": {
        "category": "neutral",
        "type": "95"
      },
      "path": [
        "neutral",
        "95"
      ]
    },
    "99": {
      "value": "#fcfcfc",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FCFCFC",
        "type": "color"
      },
      "name": "Neutral99",
      "attributes": {
        "category": "neutral",
        "type": "99"
      },
      "path": [
        "neutral",
        "99"
      ]
    },
    "100": {
      "value": "#ffffff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFFFF",
        "type": "color"
      },
      "name": "Neutral100",
      "attributes": {
        "category": "neutral",
        "type": "100"
      },
      "path": [
        "neutral",
        "100"
      ]
    }
  },
  "secondary": {
    "0": {
      "value": "#000000",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#000000",
        "type": "color"
      },
      "name": "Secondary0",
      "attributes": {
        "category": "secondary",
        "type": "0"
      },
      "path": [
        "secondary",
        "0"
      ]
    },
    "10": {
      "value": "#15121a",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#15121A",
        "type": "color"
      },
      "name": "Secondary10",
      "attributes": {
        "category": "secondary",
        "type": "10"
      },
      "path": [
        "secondary",
        "10"
      ]
    },
    "20": {
      "value": "#2a2533",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#2A2533",
        "type": "color"
      },
      "name": "Secondary20",
      "attributes": {
        "category": "secondary",
        "type": "20"
      },
      "path": [
        "secondary",
        "20"
      ]
    },
    "30": {
      "value": "#3f3a4d",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#3F3A4D",
        "type": "color"
      },
      "name": "Secondary30",
      "attributes": {
        "category": "secondary",
        "type": "30"
      },
      "path": [
        "secondary",
        "30"
      ]
    },
    "40": {
      "value": "#5a5470",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#5A5470",
        "type": "color"
      },
      "name": "Secondary40",
      "attributes": {
        "category": "secondary",
        "type": "40"
      },
      "path": [
        "secondary",
        "40"
      ]
    },
    "50": {
      "value": "#746d8f",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#746D8F",
        "type": "color"
      },
      "name": "Secondary50",
      "attributes": {
        "category": "secondary",
        "type": "50"
      },
      "path": [
        "secondary",
        "50"
      ]
    },
    "60": {
      "value": "#8e87ad",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#8E87AD",
        "type": "color"
      },
      "name": "Secondary60",
      "attributes": {
        "category": "secondary",
        "type": "60"
      },
      "path": [
        "secondary",
        "60"
      ]
    },
    "70": {
      "value": "#a9a3c7",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#A9A3C7",
        "type": "color"
      },
      "name": "Secondary70",
      "attributes": {
        "category": "secondary",
        "type": "70"
      },
      "path": [
        "secondary",
        "70"
      ]
    },
    "80": {
      "value": "#c5bfe1",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#C5BFE1",
        "type": "color"
      },
      "name": "Secondary80",
      "attributes": {
        "category": "secondary",
        "type": "80"
      },
      "path": [
        "secondary",
        "80"
      ]
    },
    "90": {
      "value": "#e2dbf9",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#E2DBF9",
        "type": "color"
      },
      "name": "Secondary90",
      "attributes": {
        "category": "secondary",
        "type": "90"
      },
      "path": [
        "secondary",
        "90"
      ]
    },
    "95": {
      "value": "#f1eeff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#F1EEFF",
        "type": "color"
      },
      "name": "Secondary95",
      "attributes": {
        "category": "secondary",
        "type": "95"
      },
      "path": [
        "secondary",
        "95"
      ]
    },
    "99": {
      "value": "#fbf8ff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FBF8FF",
        "type": "color"
      },
      "name": "Secondary99",
      "attributes": {
        "category": "secondary",
        "type": "99"
      },
      "path": [
        "secondary",
        "99"
      ]
    },
    "100": {
      "value": "#ffffff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFFFF",
        "type": "color"
      },
      "name": "Secondary100",
      "attributes": {
        "category": "secondary",
        "type": "100"
      },
      "path": [
        "secondary",
        "100"
      ]
    }
  },
  "tertiary": {
    "0": {
      "value": "#000000",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#000000",
        "type": "color"
      },
      "name": "Tertiary0",
      "attributes": {
        "category": "tertiary",
        "type": "0"
      },
      "path": [
        "tertiary",
        "0"
      ]
    },
    "10": {
      "value": "#001f2a",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#001F2A",
        "type": "color"
      },
      "name": "Tertiary10",
      "attributes": {
        "category": "tertiary",
        "type": "10"
      },
      "path": [
        "tertiary",
        "10"
      ]
    },
    "20": {
      "value": "#003547",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#003547",
        "type": "color"
      },
      "name": "Tertiary20",
      "attributes": {
        "category": "tertiary",
        "type": "20"
      },
      "path": [
        "tertiary",
        "20"
      ]
    },
    "30": {
      "value": "#004d66",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#004D66",
        "type": "color"
      },
      "name": "Tertiary30",
      "attributes": {
        "category": "tertiary",
        "type": "30"
      },
      "path": [
        "tertiary",
        "30"
      ]
    },
    "40": {
      "value": "#006c8f",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#006C8F",
        "type": "color"
      },
      "name": "Tertiary40",
      "attributes": {
        "category": "tertiary",
        "type": "40"
      },
      "path": [
        "tertiary",
        "40"
      ]
    },
    "50": {
      "value": "#0086b3",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#0086B3",
        "type": "color"
      },
      "name": "Tertiary50",
      "attributes": {
        "category": "tertiary",
        "type": "50"
      },
      "path": [
        "tertiary",
        "50"
      ]
    },
    "60": {
      "value": "#2fa3d1",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#2FA3D1",
        "type": "color"
      },
      "name": "Tertiary60",
      "attributes": {
        "category": "tertiary",
        "type": "60"
      },
      "path": [
        "tertiary",
        "60"
      ]
    },
    "70": {
      "value": "#5dbfe8",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#5DBFE8",
        "type": "color"
      },
      "name": "Tertiary70",
      "attributes": {
        "category": "tertiary",
        "type": "70"
      },
      "path": [
        "tertiary",
        "70"
      ]
    },
    "80": {
      "value": "#8adbfd",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#8ADBFD",
        "type": "color"
      },
      "name": "Tertiary80",
      "attributes": {
        "category": "tertiary",
        "type": "80"
      },
      "path": [
        "tertiary",
        "80"
      ]
    },
    "90": {
      "value": "#c7eeff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#C7EEFF",
        "type": "color"
      },
      "name": "Tertiary90",
      "attributes": {
        "category": "tertiary",
        "type": "90"
      },
      "path": [
        "tertiary",
        "90"
      ]
    },
    "95": {
      "value": "#e8f7ff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#E8F7FF",
        "type": "color"
      },
      "name": "Tertiary95",
      "attributes": {
        "category": "tertiary",
        "type": "95"
      },
      "path": [
        "tertiary",
        "95"
      ]
    },
    "99": {
      "value": "#f7fcff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#F7FCFF",
        "type": "color"
      },
      "name": "Tertiary99",
      "attributes": {
        "category": "tertiary",
        "type": "99"
      },
      "path": [
        "tertiary",
        "99"
      ]
    },
    "100": {
      "value": "#ffffff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFFFF",
        "type": "color"
      },
      "name": "Tertiary100",
      "attributes": {
        "category": "tertiary",
        "type": "100"
      },
      "path": [
        "tertiary",
        "100"
      ]
    }
  },
  "error": {
    "0": {
      "value": "#000000",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#000000",
        "type": "color"
      },
      "name": "Error0",
      "attributes": {
        "category": "error",
        "type": "0"
      },
      "path": [
        "error",
        "0"
      ]
    },
    "10": {
      "value": "#410002",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#410002",
        "type": "color"
      },
      "name": "Error10",
      "attributes": {
        "category": "error",
        "type": "10"
      },
      "path": [
        "error",
        "10"
      ]
    },
    "20": {
      "value": "#690005",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#690005",
        "type": "color"
      },
      "name": "Error20",
      "attributes": {
        "category": "error",
        "type": "20"
      },
      "path": [
        "error",
        "20"
      ]
    },
    "30": {
      "value": "#93000a",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#93000A",
        "type": "color"
      },
      "name": "Error30",
      "attributes": {
        "category": "error",
        "type": "30"
      },
      "path": [
        "error",
        "30"
      ]
    },
    "40": {
      "value": "#ba1a1a",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#BA1A1A",
        "type": "color"
      },
      "name": "Error40",
      "attributes": {
        "category": "error",
        "type": "40"
      },
      "path": [
        "error",
        "40"
      ]
    },
    "50": {
      "value": "#de3730",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#DE3730",
        "type": "color"
      },
      "name": "Error50",
      "attributes": {
        "category": "error",
        "type": "50"
      },
      "path": [
        "error",
        "50"
      ]
    },
    "60": {
      "value": "#ff5449",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FF5449",
        "type": "color"
      },
      "name": "Error60",
      "attributes": {
        "category": "error",
        "type": "60"
      },
      "path": [
        "error",
        "60"
      ]
    },
    "70": {
      "value": "#ff897d",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FF897D",
        "type": "color"
      },
      "name": "Error70",
      "attributes": {
        "category": "error",
        "type": "70"
      },
      "path": [
        "error",
        "70"
      ]
    },
    "80": {
      "value": "#ffb4ab",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFB4AB",
        "type": "color"
      },
      "name": "Error80",
      "attributes": {
        "category": "error",
        "type": "80"
      },
      "path": [
        "error",
        "80"
      ]
    },
    "90": {
      "value": "#ffdad6",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFDAD6",
        "type": "color"
      },
      "name": "Error90",
      "attributes": {
        "category": "error",
        "type": "90"
      },
      "path": [
        "error",
        "90"
      ]
    },
    "95": {
      "value": "#ffedea",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFEDEA",
        "type": "color"
      },
      "name": "Error95",
      "attributes": {
        "category": "error",
        "type": "95"
      },
      "path": [
        "error",
        "95"
      ]
    },
    "99": {
      "value": "#fffbf9",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFBF9",
        "type": "color"
      },
      "name": "Error99",
      "attributes": {
        "category": "error",
        "type": "99"
      },
      "path": [
        "error",
        "99"
      ]
    },
    "100": {
      "value": "#ffffff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFFFF",
        "type": "color"
      },
      "name": "Error100",
      "attributes": {
        "category": "error",
        "type": "100"
      },
      "path": [
        "error",
        "100"
      ]
    }
  },
  "warning": {
    "0": {
      "value": "#000000",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#000000",
        "type": "color"
      },
      "name": "Warning0",
      "attributes": {
        "category": "warning",
        "type": "0"
      },
      "path": [
        "warning",
        "0"
      ]
    },
    "10": {
      "value": "#2b1a00",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#2B1A00",
        "type": "color"
      },
      "name": "Warning10",
      "attributes": {
        "category": "warning",
        "type": "10"
      },
      "path": [
        "warning",
        "10"
      ]
    },
    "20": {
      "value": "#4a2f00",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#4A2F00",
        "type": "color"
      },
      "name": "Warning20",
      "attributes": {
        "category": "warning",
        "type": "20"
      },
      "path": [
        "warning",
        "20"
      ]
    },
    "30": {
      "value": "#6a4500",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#6A4500",
        "type": "color"
      },
      "name": "Warning30",
      "attributes": {
        "category": "warning",
        "type": "30"
      },
      "path": [
        "warning",
        "30"
      ]
    },
    "40": {
      "value": "#8c5d00",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#8C5D00",
        "type": "color"
      },
      "name": "Warning40",
      "attributes": {
        "category": "warning",
        "type": "40"
      },
      "path": [
        "warning",
        "40"
      ]
    },
    "50": {
      "value": "#a87400",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#A87400",
        "type": "color"
      },
      "name": "Warning50",
      "attributes": {
        "category": "warning",
        "type": "50"
      },
      "path": [
        "warning",
        "50"
      ]
    },
    "60": {
      "value": "#c58c00",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#C58C00",
        "type": "color"
      },
      "name": "Warning60",
      "attributes": {
        "category": "warning",
        "type": "60"
      },
      "path": [
        "warning",
        "60"
      ]
    },
    "70": {
      "value": "#e2a600",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#E2A600",
        "type": "color"
      },
      "name": "Warning70",
      "attributes": {
        "category": "warning",
        "type": "70"
      },
      "path": [
        "warning",
        "70"
      ]
    },
    "80": {
      "value": "#ffc94d",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFC94D",
        "type": "color"
      },
      "name": "Warning80",
      "attributes": {
        "category": "warning",
        "type": "80"
      },
      "path": [
        "warning",
        "80"
      ]
    },
    "90": {
      "value": "#ffe7b3",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFE7B3",
        "type": "color"
      },
      "name": "Warning90",
      "attributes": {
        "category": "warning",
        "type": "90"
      },
      "path": [
        "warning",
        "90"
      ]
    },
    "95": {
      "value": "#fff4da",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFF4DA",
        "type": "color"
      },
      "name": "Warning95",
      "attributes": {
        "category": "warning",
        "type": "95"
      },
      "path": [
        "warning",
        "95"
      ]
    },
    "99": {
      "value": "#fffbf5",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFBF5",
        "type": "color"
      },
      "name": "Warning99",
      "attributes": {
        "category": "warning",
        "type": "99"
      },
      "path": [
        "warning",
        "99"
      ]
    },
    "100": {
      "value": "#ffffff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFFFF",
        "type": "color"
      },
      "name": "Warning100",
      "attributes": {
        "category": "warning",
        "type": "100"
      },
      "path": [
        "warning",
        "100"
      ]
    }
  },
  "success": {
    "0": {
      "value": "#000000",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#000000",
        "type": "color"
      },
      "name": "Success0",
      "attributes": {
        "category": "success",
        "type": "0"
      },
      "path": [
        "success",
        "0"
      ]
    },
    "10": {
      "value": "#00210f",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#00210F",
        "type": "color"
      },
      "name": "Success10",
      "attributes": {
        "category": "success",
        "type": "10"
      },
      "path": [
        "success",
        "10"
      ]
    },
    "20": {
      "value": "#00391a",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#00391A",
        "type": "color"
      },
      "name": "Success20",
      "attributes": {
        "category": "success",
        "type": "20"
      },
      "path": [
        "success",
        "20"
      ]
    },
    "30": {
      "value": "#005227",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#005227",
        "type": "color"
      },
      "name": "Success30",
      "attributes": {
        "category": "success",
        "type": "30"
      },
      "path": [
        "success",
        "30"
      ]
    },
    "40": {
      "value": "#006d36",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#006D36",
        "type": "color"
      },
      "name": "Success40",
      "attributes": {
        "category": "success",
        "type": "40"
      },
      "path": [
        "success",
        "40"
      ]
    },
    "50": {
      "value": "#008845",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#008845",
        "type": "color"
      },
      "name": "Success50",
      "attributes": {
        "category": "success",
        "type": "50"
      },
      "path": [
        "success",
        "50"
      ]
    },
    "60": {
      "value": "#1fa35f",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#1FA35F",
        "type": "color"
      },
      "name": "Success60",
      "attributes": {
        "category": "success",
        "type": "60"
      },
      "path": [
        "success",
        "60"
      ]
    },
    "70": {
      "value": "#4bc07a",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#4BC07A",
        "type": "color"
      },
      "name": "Success70",
      "attributes": {
        "category": "success",
        "type": "70"
      },
      "path": [
        "success",
        "70"
      ]
    },
    "80": {
      "value": "#7fdc96",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#7FDC96",
        "type": "color"
      },
      "name": "Success80",
      "attributes": {
        "category": "success",
        "type": "80"
      },
      "path": [
        "success",
        "80"
      ]
    },
    "90": {
      "value": "#b8f1c3",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#B8F1C3",
        "type": "color"
      },
      "name": "Success90",
      "attributes": {
        "category": "success",
        "type": "90"
      },
      "path": [
        "success",
        "90"
      ]
    },
    "95": {
      "value": "#d6f8db",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#D6F8DB",
        "type": "color"
      },
      "name": "Success95",
      "attributes": {
        "category": "success",
        "type": "95"
      },
      "path": [
        "success",
        "95"
      ]
    },
    "99": {
      "value": "#f5fff6",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#F5FFF6",
        "type": "color"
      },
      "name": "Success99",
      "attributes": {
        "category": "success",
        "type": "99"
      },
      "path": [
        "success",
        "99"
      ]
    },
    "100": {
      "value": "#ffffff",
      "type": "color",
      "filePath": "design-tokens/color-palettes.json",
      "isSource": true,
      "original": {
        "value": "#FFFFFF",
        "type": "color"
      },
      "name": "Success100",
      "attributes": {
        "category": "success",
        "type": "100"
      },
      "path": [
        "success",
        "100"
      ]
    }
  }
} as const;

export type ColorPaletteTokens = typeof colorPaletteTokens;
